import React, { useState, useEffect } from 'react'
import countries from '../../../json/country.json'
import { useSelector, useDispatch } from 'react-redux'
import { MySwal } from '../../../lib/swal'
import { isStrongPassword, PASSWORD_RULE_TEXT } from '../../../helpers/passwordPolicy'

const RegistrationPageOneComp = (props) => {

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const dispatch = useDispatch()
    const dataInputRegistration = useSelector(state => state.dataInputRegistration)

    const handleChangeFormInput = (key, e) => {
        if (key === 'SET_HP_PIC') {
            // Hanya angka yang boleh masuk (mencegah autofill browser mengisi email/teks)
            const sanitized = e.target.value.replace(/\D/g, '');
            if (dataInputRegistration.hpPic.length === 0 && sanitized == 0 && sanitized.length > 0) {
                MySwal.fire({
                    icon: 'warning',
                    title: 'Oops, Kesalahan!',
                    text: 'Angka 0 di awal nomor tidak perlu di input',
                    confirmButtonColor: '#6e7d88',
                })
            } else {
                dispatch({ type: 'SET_HP_PIC', 'value': sanitized });
            }
        } else {
            dispatch({ type: key, 'value': e.target.value });
        }
    }

    // console.log(dataInputRegistration.hpPic)

    return (
        <>
            <div className='col-lg-12'>
                {
                    size.width < 500 ?
                        <h5>Informasi Data PIC</h5>
                        :
                        <h3 style={{ fontSize: '20px' }}>Informasi Data PIC</h3>
                }
                <hr style={{ marginBottom: '3%', marginTop: '3%' }}></hr>
            </div>
            <div className='col-lg-12' style={{ marginBottom: '3%' }}>
                <p style={{ fontSize: size.width < 500 ? '13px' : '16px', marginBottom: '3%' }}>Silahkan lengkapi data PIC berikut</p>
                <label htmlFor="sumberInformasi" className="form-label required" style={{ fontSize: size.width < 500 ? '13px' : '16px', color: (dataInputRegistration.sumberInformasi.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}>
                    Dari mana Anda mengetahui tentang program prasmul-eli ?
                </label>
                <select className="form-select" aria-label="Select example" id='sumberInformasi' onChange={(e) => handleChangeFormInput('SET_SUMBER_INFORMASI', e)} value={dataInputRegistration.sumberInformasi}
                    style={{ borderColor: (dataInputRegistration.sumberInformasi.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                >
                    <option>Pilih</option>
                    <option>Instagram</option>
                    <option>Facebook</option>
                    <option>Linkedin</option>
                    <option>Email</option>
                    <option>WhatsApp</option>
                    <option>Google</option>
                    <option>Website</option>
                    <option>Rekomendasi</option>
                </select>
            </div>
            <div className='row' style={{ marginBottom: '3%' }}>
                <div className='col-lg-2 col-12'>
                    <label style={{ fontSize: '16px', fontWeight: '600', color: (dataInputRegistration.salutationIndividu.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }} htmlFor="salutationIndividu" className="form-label required">Salutation</label>
                    <select className="form-select" aria-label="Select example" id='salutationIndividu' onChange={(e) => handleChangeFormInput('SET_SALUTATION_INDIVIDU', e)} value={dataInputRegistration.salutationIndividu}
                        style={{ borderColor: (dataInputRegistration.salutationIndividu.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                    >
                        <option value=''>Pilih</option>
                        <option value='Mr'>Mr</option>
                        <option value='Mrs'>Mrs</option>
                        <option value='Ms'>Ms</option>
                    </select>
                </div>
                <div className='col-lg-5'>
                    <label htmlFor='NamaDepan' className="form-label" style={{ fontSize: size.width < 500 ? '13px' : '16px' }}>Nama Depan</label>
                    <input type="text" id='NamaDepan' className="form-control" onChange={(e) => handleChangeFormInput('SET_NAMADEPAN_PIC', e)} value={dataInputRegistration.namaDepanPic} />
                </div>
                <div className='col-lg-5'>
                    <label htmlFor='NamaBelakang' className="form-label required" style={{ fontSize: size.width < 500 ? '13px' : '16px', color: (dataInputRegistration.namaBelakangPic.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}>Nama Belakang</label>
                    <input type="text" id='NamaBelakang' className="form-control" onChange={(e) => handleChangeFormInput('SET_NAMABELAKANG_PIC', e)} value={dataInputRegistration.namaBelakangPic}
                        style={{ borderColor: (dataInputRegistration.namaBelakangPic.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                    />
                </div>
                <p className='mt-3' style={{ fontSize: size.width < 500 ? '10px' : '12px' }}>Apabila nama anda terdiri dari satu kata: Nama Depan : <b>Budianto</b>, Nama Belakang : <b>Budianto</b></p>
            </div>
            <div className='row' style={{ marginBottom: '3%' }}>
                <div className='col-lg-6'>
                    <label htmlFor='Email' className="form-label required" style={{ fontSize: size.width < 500 ? '13px' : '16px', color: (dataInputRegistration.emailPic.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}>Email</label>
                    <input type="email" id='Email' className="form-control" onChange={(e) => handleChangeFormInput('SET_EMAIL_PIC', e)} value={dataInputRegistration.emailPic}
                        style={{ borderColor: (dataInputRegistration.emailPic.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                    />

                </div>
                <div className='row col-lg-6'>
                    <div className='col-lg-5'>
                        <label htmlFor='Country' className="form-label required" style={{ fontSize: size.width < 500 ? '13px' : '16px', color: (dataInputRegistration.codeHpPic.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}>Negara</label>
                        <select className="form-select" id='Country' onChange={(e) => handleChangeFormInput('SET_CODE_HP_PIC', e)} value={dataInputRegistration.codeHpPic}
                            style={{ borderColor: (dataInputRegistration.codeHpPic.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                        >
                            <option value="+62">Indonesia ({dataInputRegistration.codeHpPic})</option>
                            {countries.countries.map((country, key) =>
                                <option value={country.code}>{country.name} ({country.code})</option>
                            )}
                        </select>
                    </div>
                    <div className='col-lg-7'>
                        <label htmlFor='Country' className="form-label required" style={{ fontSize: size.width < 500 ? '13px' : '16px', color: (dataInputRegistration.hpPic.length < 17 && dataInputRegistration.inputAlert === true) ? '#F1415C' : '' }}>Nomor Handphone</label>
                        <input type="text" id='Country' name='nomorHandphone' autoComplete='off' inputMode='numeric' className="form-control" placeholder='81234567890' onChange={(e) => handleChangeFormInput('SET_HP_PIC', e)} value={dataInputRegistration.hpPic}
                            style={{ borderColor: (dataInputRegistration.hpPic.length < 17 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            onPaste={(e) => {
                                e.preventDefault();
                                alert("Paste tidak diperbolehkan!");
                            }}
                        />
                    </div>
                    <p className='mt-3' style={{ fontSize: size.width < 500 ? '10px' : '12px' }}>Contoh : 8123456789 (Gunakan nomor yang terhubung dengan WhatsApp)</p>
                </div>
            </div>
            <div className='row' style={{ marginBottom: '3%' }}>
                <div className='col-lg-6'>
                    <label htmlFor='Password' className="form-label required" style={{ fontSize: size.width < 500 ? '13px' : '16px', color: (dataInputRegistration.passwordPic.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}>Password</label>
                    <input type="password" id='Password' className="form-control" onChange={(e) => handleChangeFormInput('SET_PASSWORD', e)} value={dataInputRegistration.passwordPic}
                        style={{ borderColor: ((dataInputRegistration.passwordPic.length === 0 && dataInputRegistration.inputAlert === true) || (dataInputRegistration.passwordPic.length > 0 && !isStrongPassword(dataInputRegistration.passwordPic))) ? '#F1416C' : '' }}
                    />
                    <p className='mt-3' style={{ fontSize: size.width < 500 ? '10px' : '12px', color: (dataInputRegistration.passwordPic.length > 0 && !isStrongPassword(dataInputRegistration.passwordPic)) ? '#F1416C' : '' }}>{PASSWORD_RULE_TEXT}</p>
                </div>
                <div className='col-lg-6'>
                    <label htmlFor='KonfirmasiPassword' className="form-label required" style={{ fontSize: size.width < 500 ? '13px' : '16px', color: (dataInputRegistration.konfirmasiPasswordPic.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}>Konfirmasi Password</label>
                    <input type="password" id='KonfirmasiPassword' className="form-control" onChange={(e) => handleChangeFormInput('SET_CONFIRM_PASSWORD', e)} value={dataInputRegistration.konfirmasiPasswordPic}
                        style={{ borderColor: (dataInputRegistration.konfirmasiPasswordPic.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                    />
                </div>
            </div>
        </>
    )
}

export default RegistrationPageOneComp
